import packageJson from './package.json.js';
import useMounted from './src-hooks-useMounted.js';

const SetVersionOnWindow = () => {
  const isMounted = useMounted();
  if (isMounted) {
    const pricePlatformVersion = packageJson.version;
    window.PRICE_PLATFORM_VERSION = pricePlatformVersion;
  }
};

export { SetVersionOnWindow };
//# sourceMappingURL=src-util-version-logger.js.map
